import { render, staticRenderFns } from "./calendarmin.vue?vue&type=template&id=8fb672bc&scoped=true&"
import script from "./calendarmin.vue?vue&type=script&lang=js&"
export * from "./calendarmin.vue?vue&type=script&lang=js&"
import style0 from "./calendarmin.vue?vue&type=style&index=0&id=8fb672bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb672bc",
  null
  
)

export default component.exports